import { createSlice } from "@reduxjs/toolkit";
export type SideNavCollapseStatus = Boolean;

const initialState: { data: SideNavCollapseStatus } = {
  data: true,
};

export const SideNavCollapseStatusSlice = createSlice({
  name: "SideNavCollapseStatus",
  initialState,
  reducers: {
    updateSideNavCollapseStatus: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { updateSideNavCollapseStatus } =
  SideNavCollapseStatusSlice.actions;
